var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaTreniOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.26316,0H4.73684A2.66923,2.66923,0,0,0,2.10526,2.70527V14.78946a2.54355,2.54355,0,0,0,2.63158,2.44211H15.26316a2.54355,2.54355,0,0,0,2.63158-2.44211V2.70527A2.66923,2.66923,0,0,0,15.26316,0Zm1.579,14.78946a1.4916,1.4916,0,0,1-1.579,1.38948H4.73684a1.4916,1.4916,0,0,1-1.57895-1.38948V2.70527A1.614,1.614,0,0,1,4.73684,1.05263H15.26316a1.614,1.614,0,0,1,1.579,1.65264Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21,2.92V7.96A1.56219,1.56219,0,0,0,5.43,9.49V9.5l4.25.99a1.74881,1.74881,0,0,0,.32.04,1.74881,1.74881,0,0,0,.32-.04l4.25-.99a1.58172,1.58172,0,0,0,1.22-1.54V4.23H14.74V7.96a.53217.53217,0,0,1-.41.51l-4.25.99a.22073.22073,0,0,1-.16,0L5.67,8.47a.53217.53217,0,0,1-.41-.51V3.16H15.79V2.93a.81727.81727,0,0,0-.82-.82H5.03A.81516.81516,0,0,0,4.21,2.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.78947,15.12644a1.78917,1.78917,0,1,1,1.78968-1.78865A1.79148,1.79148,0,0,1,5.78947,15.12644Zm0-2.5257a.73654.73654,0,1,0,.73705.73705A.73835.73835,0,0,0,5.78947,12.60074Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.21053,15.12644a1.78917,1.78917,0,1,1,1.78968-1.78865A1.79147,1.79147,0,0,1,14.21053,15.12644Zm0-2.5257a.73654.73654,0,1,0,.737.73705A.73835.73835,0,0,0,14.21053,12.60074Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.52632,20a.52632.52632,0,0,1-.37213-.89844L2.25946,16.9963a.52626.52626,0,0,1,.74424.74424L.89844,19.84581A.52464.52464,0,0,1,.52632,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.47368,20a.52464.52464,0,0,1-.37212-.15419L16.9963,17.74054a.52626.52626,0,0,1,.74424-.74424l2.10527,2.10526A.52632.52632,0,0,1,19.47368,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,19.67369A.525.525,0,0,1,16.31579,20H3.68421A.525.525,0,0,1,3.2,19.67369a.49932.49932,0,0,1,.11584-.56847l1.05263-1.05263a.521.521,0,1,1,.73679.73686l-.14732.15792H15.04208l-.14732-.15792a.521.521,0,0,1,.73679-.73686l1.05263,1.05263A.49932.49932,0,0,1,16.8,19.67369Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaTreniOut);
export default __webpack_public_path__ + "static/media/iconaTreniOut.9120aa1b290935a6a561f63933091c5e.svg";
export { ForwardRef as ReactComponent };